export default [
  {
    title: 'breadcrumb.baccaratResult',
    route: 'list-baccarat-result',
    icon: '',
    resource: 'baccarat-result',
    action: 'read',
  }
];